<template>
    <div class="template-top">
        <el-tabs style="max-height: 80vh;margin-top:-3%;overflow: auto;" v-model="tabName" type="border-card">
            <!-- 模板信息 -->
            <el-tab-pane name="first" label="模板信息">
                <el-form size="mini" label-width="150px">
                <el-row v-if="isIntervene" >
                    <el-col :span="12">
                    <el-form-item label="流程名称">
                        <el-input v-model="templateInfo.processInstanceName"></el-input>
                    </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-tooltip  content="选择发起当前流程从属于哪个上级流程，可以形成流程上下级关系。默认可以从企业内所有的业务流程中进行选择。" effect="light" placement="top">
                            <el-form-item label="关联上级流程">
                            <el-input @focus="chooseProcess" v-model="templateInfo.parentProcessInstanceName" :disabled="readOnly" clearable @clear="clearParentProcess"></el-input>
                            </el-form-item>
                        </el-tooltip>
                    </el-col>
                </el-row>
                <el-row v-else >
                    <el-col :span="12">
                        <el-form-item label="流程名称流水号">
                            <el-radio-group v-model="templateInfo.nameGenerationMode" size="mini" >
                                <el-radio label="">不使用</el-radio>
                                <el-tooltip class="item" effect="dark" content="按照流水号规则自动生成流程名称" placement="top">
                                    <el-radio label="single">单选</el-radio>
                                </el-tooltip>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="流水号数据源" v-if="isShowSerialNumber">
                            <el-tooltip class="item" effect="dark" content="选择生成流程名称的流水号规则" placement="top">
                                <SerialNumber
                                    ref="treeChild"
                                    :selectedNode='selectedNode'
                                    :popover="true"
                                    :defaultClass="'serialnumber-tree-form'"
                                    @nodeClick="handleSerialNumberTreeNode"
                                />
                            </el-tooltip>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- <el-row v-if="isIntervene">
                    <el-form-item label="关联上级流程">
                        <el-input style="width: 200px;" @click.native="chooseProcess" v-model="templateInfo.parentProcessInstanceName" ></el-input>
                    </el-form-item>
                </el-row> -->
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="模板名称">
                                <el-tooltip class="item" effect="dark" content="流程模板的名称" placement="top">
                                    <el-input :disabled="isIntervene" v-model="templateInfo.templateName"></el-input>
                                </el-tooltip>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="业务分类">
                                <el-tooltip class="item" effect="dark" content="流程模板所属业务分类" placement="top">
                                    <BusinessTree
                                        v-if="showTree"
                                        :isRead="isIntervene"
                                        ref="busiTreeChild"
                                        :popover="true"
                                        :data="businessTree"
                                        :defaultProps="{}"
                                        :defaultClass="'business-tree-form'"
                                        @nodeClick="handleTreeNode"
                                    />
                                </el-tooltip>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                         <el-col :span="12">
                            <el-form-item label="立即执行首任务">
                                <el-radio-group v-model="templateInfo.completeFirstTask" :disabled = "isIntervene">
                                    <el-tooltip class="item" effect="dark" content="发起流程后，是否要立即执行第一个任务并完成。" placement="top">
                                        <el-radio :label="0">否</el-radio>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" content="发起流程后，是否要立即执行第一个任务并完成。" placement="top">
                                        <el-radio :label="1">是</el-radio>
                                    </el-tooltip>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="任务认领模式">
                            <el-radio-group v-model="templateInfo.claimMode" :disabled = "isIntervene">
                                <el-tooltip class="item" effect="dark" content="任务认领后，将清空候选人信息列表" placement="top">
                                    <el-radio :label="0">独占模式</el-radio>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="任务认领后，将认领人从候选人列表中删除" placement="top">
                                    <el-radio :label="1">共享模式</el-radio>
                                </el-tooltip>
                            </el-radio-group>
                          </el-form-item>
                        </el-col>
                    </el-row>
                <el-row>
                    <el-col :span="12" v-if="!isIntervene">
                        <el-form-item label="首任务负责人">
                            <el-tooltip class="item" effect="dark" content="每次发起流程，默认发起人为第一个任务的负责人" placement="top">
                                <el-checkbox v-model="templateInfo.defaultFirstAssignee" >默认发起人为首任务负责人</el-checkbox>
                            </el-tooltip>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="任务计划时间">
                            <el-tooltip class="item" effect="dark" content="任务完成后，按照顺延规则给出下一任务的计划开始和结束时间" placement="top">
                                <el-checkbox v-model="templateInfo.planTimeMode" :disabled = "isIntervene">默认任务计划时间</el-checkbox>
                            </el-tooltip>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="报表模板">
                            <el-tooltip class="item" effect="dark" content="关联了报表模型的流程实例，会采集当前流程及子流程的业务数据并以树状视图方式展示出来" placement="top">
                                <TreeSelect
                                    ref="reportTreeSelect"
                                    :sourceOptions="appModelsOptions"
                                    @treeSelectChoose="handleSelectForm"
                                />
                            </el-tooltip>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="档案模板">
                            <el-tooltip class="item" effect="dark" content="发起流程后，当前流程将按照档案模板的层级结构对该流程中上传的文件进行归档" placement="top">
                                <el-select v-model="templateInfo.archiveTemplateId" @change="chooseArchiveTemplate" clearable placeholder="请选择">
                                    <el-option
                                    v-for="item in archiveTemplateList"
                                    :key="item.id"
                                    :label="item.templateName"
                                    :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-tooltip>
                        </el-form-item>
                    </el-col>
                </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="项目模板">
                                <el-tooltip class="item" effect="dark" content="实现对流程任务的精细化管理，例如：配置任务计划时间、查看项目甘特图等" placement="top">
                                    <el-select v-model="templateInfo.timeTemplateId" @change="chooseTimeTemplate" clearable placeholder="请选择">
                                        <el-option
                                        v-for="item in timeTemplateList"
                                        :key="item.id"
                                        :label="item.templateName"
                                        :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-tooltip>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="闭环模板">
                                <el-tooltip class="item" effect="dark" content="流程实例满足闭环模板中设置的闭环条件后变为闭环状态" placement="top">
                                    <el-select v-model="templateInfo.closeTemplateId" @change="chooseCloseTemplate" clearable placeholder="请选择">
                                        <el-option
                                        v-for="item in closeTemplateList"
                                        :key="item.id"
                                        :label="item.templateName"
                                        :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-tooltip>
                            </el-form-item>
                        </el-col>
                    </el-row>
                     <el-row>
                        <el-col :span="12">
                            <el-form-item label="自动完成任务">
                                <el-tooltip class="item" effect="dark" content="例如：流程有三个任务节点，分别是申请、一审、二审等，一审通过、二审驳回到了申请节点。如果设置了自动完成，则申请节点再次完成后，系统就会自动完成上次已经通过的一审任务，直接到达二审任务了。" placement="top">
                                    <el-radio-group v-model="templateInfo.autoCompleteTask" :disabled = "isIntervene">
                                        <el-radio :label="0">否</el-radio>
                                        <el-radio :label="1">是</el-radio>
                                    </el-radio-group>
                                </el-tooltip>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="文件及留言互为可见">
                                <el-tooltip class="item" effect="dark" content="同流程内的文件和任务留言都不受权限限制，各个任务之间都互为可见" placement="top">
                                    <el-radio-group v-model="templateInfo.canViewAllFile" :disabled = "isIntervene">
                                        <el-radio :label="0">否</el-radio>
                                        <el-radio :label="1">是</el-radio>
                                    </el-radio-group>
                                </el-tooltip>
                            </el-form-item>
                        </el-col>
                    </el-row>
                     <el-row>
                        <el-col :span="24">
                            <el-form-item label="使用说明">
                                <el-input :disabled="isIntervene" type="textarea" :rows="2" placeholder="请输入内容" v-model="templateInfo.templateDesc" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row >
                      <el-col :span="12" >
                          <el-form-item label="关联上级流程必填">
                              <el-tooltip class="item" effect="dark" content="发起流程时，关联上级流程是否必填" placement="top">
                                  <el-checkbox v-model="templateInfo.parentProcessInstanceMode" :disabled = "isIntervene" ></el-checkbox>
                              </el-tooltip>
                          </el-form-item>
                      </el-col>
                      <el-col :span="12">
                          <el-form-item label="任务的负责人必填">
                              <el-tooltip class="item" effect="dark" content="发起流程时，任务列表界面的任务负责人是否必填" placement="top">
                                  <el-checkbox v-model="templateInfo.processTaskAssignerMode" :disabled = "isIntervene" ></el-checkbox>
                              </el-tooltip>
                          </el-form-item>
                      </el-col>
                  </el-row>
                    <el-tooltip class="item" effect="dark" content="我的流程界面默认显示【流程记录】、【文件列表】、【沟通留言】、【审批流列表】、【流程动态】、【关闭文件上传】五个页签内容，可以选择取消对应页签。" placement="top">
                      <el-form-item label="流程界面显示">
                          <el-checkbox-group v-model="processViewPaneList" @change="handleProcessCheckedPaneChange">
                              <el-checkbox label="流程记录" disabled></el-checkbox>
                              <el-checkbox label="文件列表"></el-checkbox>
                              <el-checkbox label="沟通留言"></el-checkbox>
                              <el-checkbox label="审批流列表"></el-checkbox>
                              <el-checkbox label="流程动态" ></el-checkbox>
                              <el-checkbox label="关闭文件上传" ></el-checkbox>
                          </el-checkbox-group>
                      </el-form-item>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="我的任务界面默认显示【文件列表】、【沟通留言】、【审批流列表】、【已完成任务关闭文件上传】四个页签内容，可以选择取消对应页签。" placement="top">
                      <el-form-item label="任务界面显示">
                            <el-checkbox-group v-model="taskViewPaneList" @change="handleTaskCheckedPaneChange">
                                <el-checkbox label="文件列表"></el-checkbox>
                                <el-checkbox label="沟通留言"></el-checkbox>
                                <el-checkbox label="审批流列表"></el-checkbox>
                                <el-checkbox label="已完成任务关闭文件上传" ></el-checkbox>
                            </el-checkbox-group>
                      </el-form-item>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="列出当前流程模板里所有任务，默认都可以上传文件，可以选择对应的任务禁止上传文件" placement="top">
                      <el-form-item label="禁止文件上传的任务">
                          <el-checkbox-group v-model="checkedClosedTaskFileUpload" @change="handleClosedTaskFileUploadChange">
                            <div class="field-item" v-for="item in tasksList">  
                                <el-checkbox :label="item.taskId+item.taskName" :key="item.taskId">{{item.taskName}}</el-checkbox>
                            </div>
                          </el-checkbox-group>
                      </el-form-item>
                    </el-tooltip>
                </el-form>
            </el-tab-pane>
            <!-- 流程表单 -->
            <el-tab-pane name="second" label="流程表单">
                <DataOperateEdit ref="dataOperate" :dataOperate='templateInfo.dataOperate'/>
            </el-tab-pane>
        </el-tabs>
        <el-dialog
            title="选择所属流程"
            :visible.sync="isShowProcessListDialog"
            append-to-body
            custom-class="belongProcess"
            top="0vh"
            width = "80%">
            <!-- <ProcessPop  :field="{}" ref="processSelect" :formData="{}" @nodeClick="selectTrigger" :unNeedAuth="true" :hideBtn="true"/> -->
            <ProcessSelectPop  ref="processSelect" :multiple="false" :selectedProcess="selectedProcess" :formData="{}" :field="{}" @nodeClick="selectProcessTrigger" />
            <!-- <span slot="footer" class="dialog-footer">
                <el-button  type="primary" @click="handleClickOk">确定</el-button>
            </span> -->
        </el-dialog>
    </div>
</template>

<script>
    import { getApplicationModelTreeList, getAllUserTask, getBusinessTreeList, getArchiveTemplateList, getServiceTimeTemplateList, getProcessCloseTemplateList } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';
    import { isEmpty, cloneDeep } from 'lodash';
    import DataOperateEdit from '../ProcessEditor/components/DataOperateEdit';
    import SerialNumber from '@/components/SerialNumber';

    import { CONST_PERMISSION_PROCESS_START_PROCESS_TEMPLATE_BTN,
        CONST_PERMISSION_PROCESS_DESIGN_PROCESS_TEMPLATE_BTN,
        CONST_PERMISSION_PROCESS_PUBLISH_PROCESS_TEMPLATE_BTN,
        CONST_PERMISSION_PROCESS_PREVIEW_PROCESS_TEMPLATE_BTN,
        CONST_PERMISSION_PROCESS_CONFIG_PROCESS_TEMPLATE_BTN
    } from '@/common/constants';

    export default {
        components: {
            DataOperateEdit,
            SerialNumber
            // WorkflowEditor
        },
        mixins: [ mixinsNav ],
        data () {
            return {
                readOnly: false, // 上级流程只读标识
                processViewPaneList: ['流程记录', '文件列表', '沟通留言', '审批流列表', '流程动态'],
                taskViewPaneList: ['文件列表', '沟通留言', '审批流列表'],
                appModelsOptions: [],
                isShowProcessListDialog: false,
                showTree: false,
                tabName: 'first',
                archiveTemplateList: [],
                timeTemplateList: [],
                closeTemplateList: [],
                businessTree: [],
                permission: {
                    startProcessTemplateBtn: [
                        CONST_PERMISSION_PROCESS_START_PROCESS_TEMPLATE_BTN
                    ],
                    designProcessTemplateBtn: [
                        CONST_PERMISSION_PROCESS_DESIGN_PROCESS_TEMPLATE_BTN
                    ],
                    publishProcessTemplateBtn: [
                        CONST_PERMISSION_PROCESS_PUBLISH_PROCESS_TEMPLATE_BTN
                    ],
                    previewProcessTemplateBtn: [
                        CONST_PERMISSION_PROCESS_PREVIEW_PROCESS_TEMPLATE_BTN
                    ],
                    configProcessTemplateBtn: [
                        CONST_PERMISSION_PROCESS_CONFIG_PROCESS_TEMPLATE_BTN
                    ]
                },
                tasksList: [],
                checkedClosedTaskFileUpload: [],
                selectedProcess: {
                    selectedProcessIds: '',
                    selectedProcessNames: ''
                }
            };
        },
        created () {
            // this._initPage();
        },
        props: {
            saveMode: {
                type: Number,
                default: 0// 0:修改 1发布
            },
            templateInfo: {
                type: Object,
                default: function () {
                    return {
                        parentTaskInstanceId: '',
                        processInstanceName: '',
                        processServiceName: '',
                        processServiceId: '',
                        deploymentId: '',
                        id: '',
                        templateName: '',
                        templateDesc: '',
                        archiveTemplateId: '', // 档案模板
                        archiveTemplateName: '',
                        timeTemplateId: '',
                        timeTemplateName: '',
                        closeTemplateId: '',
                        closeTemplateName: '',
                        processServiceType: '',
                        nameGenerationMode: '', // 流程名称生成方式
                        defaultFirstAssignee: 0, // 是否默认首任务负责人为发起人
                        parentProcessInstanceMode: 0, // 关联上级流程是否必填：0否1是，默认为0
                        processTaskAssignerMode: 0, // 流程所有任务的负责人是否必填：0否1是，默认为0
                        autoCompleteTask: 0, // 是否自动完成任务
                        canViewAllFile: 0, // 同流程内的文件不受权限限制，都互为可见：0否1是，默认为0
                        claimMode: 0, // 任务认领模式
                        completeFirstTask: 0, // 是否立即执行首任务
                        planTimeMode: 0, // 默认任务计划时间
                        dataOperate: {
                            dataSource: 2,
                            forms: []
                        },
                        processInstanceId: '',
                        parentProcessInstanceId: '',
                        parentProcessInstanceName: '',
                        processViewPanes: null, // 流程界面默认显示页签
                        taskViewPanes: null, // 任务界面默认显示页签
                        processExtJson: null,
                        reports: [] // 挂载的报表
                    };
                }
            },
            isIntervene: { // 是否流程干预
                type: Boolean,
                default: false
            }
        },
        computed: {
            isShowSerialNumber () { // 流水号
                return this.templateInfo.nameGenerationMode === 'single' || this.templateInfo.nameGenerationMode === 'multi';
            },
            selectedNode () {
                // console.log(this.templateInfo.nameGenerationMode);
                if (this.isShowSerialNumber) {
                    if (this.templateInfo.serialNumberJson) {
                        let serialNumberData = JSON.parse(this.templateInfo.serialNumberJson);
                        // console.log(serialNumberData);
                        setTimeout(() => { // 调用子组件的方法
                            this.$refs.treeChild._refreshSelectedNode(serialNumberData);
                        }, 0);
                    } else {
                        return {
                            id: 0,
                            lable: ''
                        };
                    }
                }
            }
        },
        methods: {
            async _initPage (process) {
                // console.log(process);
                // 上级流程选择框，如果是任务中发起的流程，则锁死
                if (!isEmpty(process.parentProcessInstanceId) && !isEmpty(process.parentTaskInstanceId)) {
                    this.readOnly = true;
                }
                if (this.isIntervene) {
                    this.templateInfo.processInstanceId = process.processInstanceId;
                }
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let archiveTemplateList = await getArchiveTemplateList({ state: 1 });
                this.archiveTemplateList = archiveTemplateList.data;
                // if (process.processInstanceId) {
                //     timeTemplateList = await getServiceTimeTemplateInstanceList({ currentPage: 0, pageSize: 500, processInstanceId: process.processInstanceId, processServiceId: process.processServiceId, deploymentId: process.deploymentId });
                // } else {
                let timeTemplateList = await getServiceTimeTemplateList({ currentPage: 0, pageSize: 500, processServiceId: process.processServiceId, deploymentId: process.deploymentId });
                // }
                this.timeTemplateList = timeTemplateList.data;

                let closeTemplateList = await getProcessCloseTemplateList({ currentPage: 0, pageSize: 500 });
                this.closeTemplateList = closeTemplateList.data;

                let treeList = await getBusinessTreeList();
                this.businessTree = treeList;
                this.showTree = true;
                this.resetShowStatus(process);
                this.getApplicationModelTreeList();
                if (this.templateInfo && this.templateInfo.processViewPanes) {
                    this.processViewPaneList = this.templateInfo.processViewPanes.split(',');
                }
                if (this.templateInfo && this.templateInfo.taskViewPanes) {
                    this.taskViewPaneList = this.templateInfo.taskViewPanes.split(',');
                }
                if (this.templateInfo && this.templateInfo.processExtJson) {
                    // console.log(this.templateInfo.processExtJson);
                    let processExtJson = JSON.parse(this.templateInfo.processExtJson);
                    if (processExtJson.checkedClosedTaskFileUpload) {
                        this.checkedClosedTaskFileUpload = processExtJson.checkedClosedTaskFileUpload.split(',');
                    }
                }
                await this.initTaskListTemplate(process);
                loading.close();
                // console.log("===="+this.permission.designProcessTemplateBtn);
            },
            resetShowStatus (process) {
                let node = {};
                node.value = process.processServiceType;
                node.title = process.processServiceTypeName;
                setTimeout(() => { // 默认回显值
                    this.$refs.busiTreeChild._refreshSelectedNode(node);
                }, 0);
                this.tabName = 'first';
            },
            handleTreeNode (data, node, tree) {
                this.templateInfo.processServiceType = data.id;
            },
            handleSerialNumberTreeNode (data, node, tree) {
                let obj = {
                    title: data.label,
                    value: data.id
                };
                this.templateInfo.serialNumberJson = JSON.stringify(obj);
                // console.log(this.templateInfo.serialNumberJson);
            },
            chooseArchiveTemplate () {

            },
            chooseTimeTemplate () {

            },
            chooseCloseTemplate () {

            },
            chooseProcess () {
                if (!this.readOnly) {
                    this.selectedProcess = {
                        selectedProcessIds: this.templateInfo.parentProcessInstanceId,
                        selectedProcessNames: this.templateInfo.parentProcessInstanceName
                    };
                    this.isShowProcessListDialog = true;
                }
            },
            selectProcessTrigger(selected) { // 选择流程
                if (this.templateInfo.processInstanceId === selected.selectedProcessIds) {
                    this.$message({
                        message: '不能选择自己做为上级流程',
                        type: 'warning',
                        duration: 3000
                    });
                } else {
                    this.templateInfo.parentProcessInstanceId = selected.selectedProcessIds;
                    this.templateInfo.parentProcessInstanceName = selected.selectedProcessNames;
                    this.isShowProcessListDialog = false;
                }
            },
            selectTrigger (selected) { // 选择流程
                // this.searchParams.processInstanceId = selected.id;
                // this.searchParams.processInstanceName = selected.label;
                this.templateInfo.parentProcessInstanceId = '';
                this.templateInfo.parentProcessInstanceName = '';
                if (this.templateInfo.processInstanceId === selected.id) {
                    this.$message({
                        message: '不能选择自己做为上级流程',
                        type: 'warning',
                        duration: 3000
                    });
                } else {
                    this.templateInfo.parentProcessInstanceId = selected.id;
                    this.templateInfo.parentProcessInstanceName = selected.label;
                }
            },
            clearParentProcess () {
                this.templateInfo.parentProcessInstanceId = '';
                this.templateInfo.parentProcessInstanceName = '';
                this.isShowProcessListDialog = false;
            },
            async handleClickOk () {
                let res = this.$refs.processSelect.confirmChooseProcess();
                this.selectTrigger(res);
                this.isShowProcessListDialog = false;
            },
            // 挂载报表模型
            async getApplicationModelTreeList () {
                let modelTree = await getApplicationModelTreeList({
                    currentPage: 1,
                    pageSize: 100,
                    state: 1,
                    modelType: 2
                });
                if (modelTree) {
                    this.appModelsOptions = modelTree;
                }
                this.initReportTreeSelect();
            },
            initReportTreeSelect () {
                if (this.templateInfo.reports) {
                    setTimeout(() => {
                        let selectedTree = [];
                        this.templateInfo.reports.forEach((item) => {
                            if (item.modelId) {
                                selectedTree.push(item.modelId);
                            }
                        });
                        if (this.$refs.reportTreeSelect) {
                            this.$refs.reportTreeSelect.initParam(selectedTree);
                        }
                    }, 0);
                }
            },
            handleSelectForm (selectObj) {
                let selectedModel = cloneDeep(selectObj);
                if (Array.isArray(selectedModel)) {
                    let tempArr = [];
                    selectedModel.forEach(item => { // 再补充本次选择的
                        item.modelId = item.id;
                        item.id = item.formId;
                        item.formName = item.name;
                        tempArr.push(item);
                    });
                    // this.addForms(item);
                    this.templateInfo.reports = tempArr;
                }
                // console.log(this.dataOperate.forms);
            },
            handleProcessCheckedPaneChange (value) {
                // let checkedCount = value.length;
                this.templateInfo.processViewPanes = value.join(',');
                // console.log(this.templateInfo.processViewPanes);
            },
            handleTaskCheckedPaneChange (value) {
                // let checkedCount = value.length;
                this.templateInfo.taskViewPanes = value.join(',');
                // console.log(this.templateInfo.taskViewPanes);
            },
            handleClosedTaskFileUploadChange (value) {
                let processExtJson;
                if (this.templateInfo.processExtJson) {
                    processExtJson = JSON.parse(this.templateInfo.processExtJson);
                } else {
                    processExtJson = {checkedClosedTaskFileUpload: ''};
                }
                processExtJson.checkedClosedTaskFileUpload = value.join(',');
                this.templateInfo.processExtJson = JSON.stringify(processExtJson);
            },
            async initTaskListTemplate (process) {
                let tasks = [];
                if (this.templateInfo.processInstanceId) {
                    tasks = await getAllUserTask(this.templateInfo.processInstanceId, process.processServiceId, null, process.deploymentId);
                } else {
                    tasks = await getAllUserTask(null, process.processServiceId, process.id, process.deploymentId);
                }
                this.tasksList = tasks;
            }
        }
    };
</script>


<style lang="less">
.template-top{
  .el-tabs__content{
    margin-top: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/process/ProcessTemplate/TemplatePop.vue